var render, staticRenderFns
import script from "./vuetableFormatters.vue?vue&type=script&lang=js&"
export * from "./vuetableFormatters.vue?vue&type=script&lang=js&"
import style0 from "./vuetableFormatters.vue?vue&type=style&index=0&id=04db1961&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports